<template>
    <v-card>
        <v-card-text>
            <v-switch v-model="gitlab.enable" :label="$t('projects.gitlab.enable')"></v-switch>
            <v-text-field
                v-model="gitlab.url"
                :label="$t('projects.gitlab.url')"
                required
                outlined
                color="red"
            ></v-text-field>
            <v-text-field v-model="gitlab.token" :label="$t('projects.gitlab.token')" outlined disabled></v-text-field>

            <v-btn color="success" class="mr-4" @click="submitForm">
                {{ $t('projects.actions.update') }}
            </v-btn>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Clone from 'lodash/cloneDeep';

export default {
    name: 'project-setting-gitlab',
    data: () => ({
        gitlab: {},
    }),
    created() {
        this.updateForm(this.project);
    },
    watch: {
        project: function (value) {
            this.updateForm(value);
        },
    },
    computed: {
        ...mapGetters(['project']),
    },
    methods: {
        ...mapActions(['updateIntegration']),
        updateForm(p) {
            if (p) {
                this.gitlab = Clone(p.integrations.gitlab);
            }
        },
        submitForm() {
            const projectToUpdate = {
                id: this.project.id,
                tool: 'gitlab',
                enable: this.gitlab.enable,
                url: this.gitlab.url,
            };
            this.updateIntegration(projectToUpdate);
        },
    },
};
</script>

<style></style>
